import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

module.exports = {
    createFetchParams: (filters, pagination, sortBy) => ({
        ...filters,
        ...pagination,
        ordering: sortBy
    }),
    ...storeModuleFactory({
        name:            'reservations',
        endpoint:        endpoints.reservations.endpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        filterParamsMap: {
            instanceType: 'instance_type'
        },
        sortParamsMap: {
            reservationId: 'reservation_id',
            productName:   'aws_product',
            accountName:   'account',
            instanceType:  'instance_type',
            qty:           'instance_count'
        },
        transformEntitiesFn: item => ({
            reservationId: item.reservation_id,
            productName:   item.aws_product.name,
            accountName:   item.account.name,
            region:        item.region,
            instanceType:  item.instance_type,
            qty:           item.instance_count,
            state:         item.state,
            offeringType:  item.offering_type,
            account:       item.account.name,
            startDate:     item.start * TIMESTAMP_MULTIPLY,
            endDate:       item.end * TIMESTAMP_MULTIPLY,
            duration:      item.duration
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/reservations.js